var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { useLayoutEffect, useRef, } from 'react';
import { css } from '@emotion/core';
import { useShallowCompareEffect } from '@core/hooks/useShallowCompareEffect';
import { logError } from '@src/core/logging';
export const VideoComponent = (_a) => {
    var { videoWrapper, containerProps } = _a, props = __rest(_a, ["videoWrapper", "containerProps"]);
    const ref = useRef(null);
    useLayoutEffect(() => {
        if (ref.current) {
            while (ref.current.firstChild) {
                ref.current.firstChild.remove();
            }
            ref.current.appendChild(videoWrapper.getContainer());
        }
    }, [videoWrapper]);
    useShallowCompareEffect(() => {
        // Rebind video props on video change
        if (videoWrapper) {
            Object.entries(props).forEach(([key, value]) => {
                if (typeof value !== 'undefined') {
                    if (key in videoWrapper) {
                        videoWrapper[key] = value;
                    }
                    else if (key.toLowerCase() in videoWrapper) {
                        videoWrapper[key.toLowerCase()] = value;
                    }
                    else {
                        logError(new Error(`"${key}" is not implemented on IVideoWrapper`));
                    }
                }
            });
        }
    }, [props, videoWrapper]);
    return (<div {...(containerProps || {})}>
      <div css={css `
          width: 100%;
          height: 100%;
        `} ref={ref}/>
    </div>);
};
